var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9 documentPreview"},[_c('iframe',{staticStyle:{"height":"650px","width":"100%","border":"none"},attrs:{"frameborder":"0","scrolling":"no","src":_vm.iframesrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }